import { supabase } from '../lib/supabase';
import { assertContentIsAllowed } from '../lib/contentModeration';

export const collectionsService = {
  async getUserCollections(userId?: string) {
    const { data: { user } } = await supabase.auth.getUser();
    const targetUserId = userId || user?.id;
    
    if (!targetUserId) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('collections')
      .select(`
        *,
        collection_posts (
          post_id,
          posts (
            id,
            title,
            media_files (
              id,
              type,
              url
            )
          )
        )
      `)
      .eq('user_id', targetUserId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  async createCollection(name: string, description?: string, isPublic: boolean = false) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('User not authenticated');

    await assertContentIsAllowed([name, description]);

    const { data, error } = await supabase
      .from('collections')
      .insert({
        user_id: user.id,
        name,
        description,
        is_public: isPublic,
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async addPostToCollection(collectionId: string, postId: string) {
    const { data, error } = await supabase
      .from('collection_posts')
      .insert({
        collection_id: collectionId,
        post_id: postId,
      });

    if (error) throw error;
    return data;
  },

  async removePostFromCollection(collectionId: string, postId: string) {
    const { error } = await supabase
      .from('collection_posts')
      .delete()
      .eq('collection_id', collectionId)
      .eq('post_id', postId);

    if (error) throw error;
  },

  async deleteCollection(collectionId: string) {
    const { error } = await supabase
      .from('collections')
      .delete()
      .eq('id', collectionId);

    if (error) throw error;
  },

  async checkIfPostInCollection(postId: string, collectionId: string) {
    const { data, error } = await supabase
      .from('collection_posts')
      .select('id')
      .eq('collection_id', collectionId)
      .eq('post_id', postId)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return !!data;
  },
};
